module.exports = __webpack_public_path__ + "media/img/favicon/mstile-150x150-096e57b073c8b4828b91886e5177b3dc.png";